import Modal from 'flarum/common/components/Modal';
import app from 'flarum/forum/app';
import Button from 'flarum/common/components/Button';
import Select from 'flarum/common/components/Select';
import setRouteWithForcedRefresh from 'flarum/common/utils/setRouteWithForcedRefresh';
export default class CreateItemModal extends Modal {
  loading = false;
  selectedProvider = "unknown";
  selectedData = "unknown";
  selectedSpecialData = "";
  providers = (() => ({
    unknown: app.translator.trans("xypp-store.forum.create-modal.providers.unknown")
  }))();
  providerDatas = (() => ({
    unknown: app.translator.trans("xypp-store.forum.create-modal.providers.unknown_data")
  }))();
  specialDatas = {};
  className() {
    return 'Modal--small';
  }
  title() {
    if (this.attrs?.item_id) {
      return app.translator.trans("xypp-store.forum.create-modal.edit-title", [this.attrs?.item_id]);
    }
    return app.translator.trans('xypp-store.forum.create-modal.title');
  }
  onupdate(vnode) {
    this.$("#xypp-store-create-selector-provider_data").val(this.selectedData);
    this.$("#xypp-store-create-selector-provider").val(this.selectedProvider);
  }
  oncreate(vnode) {
    super.oncreate(vnode);
    if (this.attrs.item_id) {
      const data = app.store.getById('store-item', this.attrs.item_id);
      this.$('#xypp-store-create-ipt-name').val(data?.attribute("name"));
      this.$('#xypp-store-create-ipt-desc').val(data?.attribute("desc"));
      this.$('#xypp-store-create-ipt-price').val(data?.attribute("price"));
      this.$('#xypp-store-create-ipt-provider').val(data?.attribute("provider"));
      this.$('#xypp-store-create-ipt-provider_data').val(data?.attribute("provider_data"));
      this.$('#xypp-store-create-ipt-expire_time').val(data?.attribute("expire_time"));
      this.$('#xypp-store-create-ipt-rest_cnt').val(data?.attribute("rest_cnt"));
      this.$('#xypp-store-create-ipt-use_cnt').val(data?.attribute("use_cnt"));
    }
  }
  content() {
    const that = this;
    return m("div", {
      className: "Modal-body"
    }, m("div", {
      className: "Form"
    }, m("div", {
      className: "Form-group"
    }, m("label", {
      for: "xypp-store-create-ipt-name"
    }, app.translator.trans('xypp-store.forum.create-modal.name')), m("input", {
      id: "xypp-store-create-ipt-name",
      required: true,
      className: "FormControl",
      type: "text",
      step: "any"
    })), m("div", {
      className: "Form-group"
    }, m("label", {
      for: "xypp-store-create-ipt-desc"
    }, app.translator.trans('xypp-store.forum.create-modal.desc')), m("textarea", {
      id: "xypp-store-create-ipt-desc",
      required: true,
      className: "FormControl",
      step: "any"
    })), m("div", {
      className: "Form-group"
    }, m("label", {
      for: "xypp-store-create-ipt-price"
    }, app.translator.trans('xypp-store.forum.create-modal.price')), m("input", {
      id: "xypp-store-create-ipt-price",
      required: true,
      className: "FormControl",
      type: "number",
      step: "any"
    })), m("div", {
      className: "Form-group"
    }, m("label", {
      for: "xypp-store-create-ipt-use_cnt"
    }, app.translator.trans('xypp-store.forum.create-modal.use_cnt')), m("input", {
      id: "xypp-store-create-ipt-use_cnt",
      className: "FormControl",
      step: "any"
    })), m("div", {
      className: "Form-group"
    }, m("label", {
      for: "xypp-store-create-ipt-expire_time"
    }, app.translator.trans('xypp-store.forum.create-modal.expire_time')), m("input", {
      id: "xypp-store-create-ipt-expire_time",
      className: "FormControl",
      step: "any"
    }), m("p", null, app.translator.trans('xypp-store.forum.create-modal.expire_time_tip'))), m("div", {
      className: "Form-group"
    }, m("label", {
      for: "xypp-store-create-ipt-rest_cnt"
    }, app.translator.trans('xypp-store.forum.create-modal.rest_cnt')), m("input", {
      id: "xypp-store-create-ipt-rest_cnt",
      className: "FormControl",
      step: "any"
    }), m("p", null, app.translator.trans('xypp-store.forum.create-modal.rest_cnt_tip'))), m("div", {
      className: "Form-group"
    }, m("label", {
      for: "xypp-store-create-ipt-provider"
    }, app.translator.trans('xypp-store.forum.create-modal.provider')), m(Select, {
      id: "xypp-store-create-selector-provider",
      value: this.selectedProvider,
      options: this.providers,
      onchange: this.changeProvider.bind(this)
    })), m("div", {
      className: "Form-group"
    }, m("label", {
      for: "xypp-store-create-ipt-provider_data"
    }, app.translator.trans('xypp-store.forum.create-modal.provider_data')), m(Select, {
      id: "xypp-store-create-selector-provider_data",
      value: this.selectedData,
      options: this.providerDatas,
      onchange: this.changeProviderData.bind(this)
    }), m("div", {
      id: "xypp-store-create-selector-provider_special"
    }, this.selectedSpecialData)), m("div", {
      className: "Form-group store-control-spacing"
    }, m(Button, {
      class: "Button Button--primary",
      type: "submit",
      loading: this.loading
    }, this.attrs.item_id ? app.translator.trans('xypp-store.forum.create-modal.edit-button') : app.translator.trans('xypp-store.forum.create-modal.button')), this.attrs.item_id ? m(Button, {
      class: "Button Button--danger",
      loading: this.loading,
      disabled: this.loading,
      onclick: this.delete.bind(this)
    }, m("i", {
      class: "fas fa-trash"
    }), app.translator.trans('xypp-store.forum.create-modal.delete-button')) : "")));
  }
  async onsubmit(e) {
    e.preventDefault();
    if (this.selectedData === "unknown" || this.selectedProvider === "unknown" || this.selectedProvider.startsWith("to_select_")) {
      if (this.attrs.item_id) {
        const data = app.store.getById('store-item', this.attrs.item_id);
        this.selectedData = data?.attribute("provider_data");
        this.selectedProvider = data?.attribute("provider");
      } else {
        app.alerts.show({
          type: 'error'
        }, app.translator.trans('xypp-store.forum.create-modal.provider_data_error'));
        return;
      }
    }
    let providerData = this.selectedData;
    if (this.selectedData === "___special") {
      if (this.selectedSpecialData) {
        providerData = this.selectedSpecialData;
      } else {
        app.alerts.show({
          type: 'error'
        }, app.translator.trans('xypp-store.forum.create-modal.provider_data_error'));
      }
    }
    this.loading = true;
    try {
      const ret = await app.request({
        url: app.forum.attribute('apiUrl') + '/store-item',
        method: 'POST',
        body: {
          attributes: {
            id: this.attrs.item_id || undefined,
            name: this.$('#xypp-store-create-ipt-name').val(),
            desc: this.$('#xypp-store-create-ipt-desc').val(),
            price: this.$('#xypp-store-create-ipt-price').val(),
            provider: this.selectedProvider,
            provider_data: providerData,
            rest_cnt: this.$('#xypp-store-create-ipt-rest_cnt').val(),
            expire_time: this.$('#xypp-store-create-ipt-expire_time').val(),
            use_cnt: this.$('#xypp-store-create-ipt-use_cnt').val()
          }
        }
      });
      app.modal.close();
      const model = app.store.pushPayload(ret);
      if (this.attrs.onSubmit) {
        return this.attrs.onSubmit(model);
      }
      setRouteWithForcedRefresh(app.route("storePage"));
    } catch (e) {
      app.alerts.show({
        type: 'error'
      }, e.toString());
      this.loading = false;
    }
  }
  async delete(e) {
    e.preventDefault();
    if (!confirm(app.translator.trans('xypp-store.forum.create-modal.confirm_delete'))) {
      return;
    }
    this.loading = true;
    m.redraw();
    try {
      const data = app.store.getById('store-item', this.attrs.item_id);
      await app.request({
        method: 'POST',
        url: app.forum.attribute('apiUrl') + '/store-item/' + this.attrs.item_id + "/delete"
      });
      app.modal.close();
      if (this.attrs.onDelete) {
        this.loading = false;
        return this.attrs.onDelete(data);
      } else setRouteWithForcedRefresh(app.route("storePage"));
    } catch (e) {
      this.loading = false;
    }
  }
  async getProviderData(e) {
    if (e == "unknown") {
      this.providerDatas = {
        unknown: app.translator.trans("xypp-store.forum.create-modal.providers.unknown_data")
      };
    } else {
      this.selectedData = "to_select_" + e;
      this.providerDatas[this.selectedData] = app.translator.trans("xypp-store.forum.create-modal.providers.no_select_data");
    }
    m.redraw();
    this.loading = false;
  }
  changeProvider(e) {
    this.selectedProvider = e;
    if (e == "unknown" || e.startsWith("to_select_")) {
      return;
    }
    this.$('#xypp-store-create-ipt-provider').val(e);
    this.loading = true;
    this.providerDatas = {};
    this.$('#xypp-store-create-ipt-provider_data').val("unknown");
    this.selectedData = "unknown";
    this.selectedSpecialData = "";
    this.getProviderData(e);
  }
  changeProviderData(e) {
    if (this.specialDatas[e]) {
      this.specialDatas[e]().then(this.changeSpecialData.bind(this)).catch(this.clearSpecialData.bind(this));
    } else {
      this.selectedSpecialData = "";
      if (this.providerDatas['___special']) {
        delete this.providerDatas['___special'];
      }
    }
    this.selectedData = e;
    if (e == "unknown" || e.startsWith("to_select_")) {
      return;
    }
    this.$('#xypp-store-create-ipt-provider_data').val(e);
    m.redraw();
  }
  changeSpecialData(e) {
    this.$("#xypp-store-create-selector-provider_special").text(e);
    this.providerDatas["___special"] = app.translator.trans("xypp-store.forum.create-modal.providers.special_data");
    this.selectedData = "___special";
    this.selectedSpecialData = e;
    m.redraw();
  }
  clearSpecialData() {
    this.$("#xypp-store-create-selector-provider_special").text("");
    this.selectedData = "unknown";
    if (this.providerDatas['___special']) {
      delete this.providerDatas['___special'];
    }
    this.selectedSpecialData = "unknown";
    m.redraw();
  }
}
flarum.reg.add('xypp-store', 'forum/components/CreateItemModal', CreateItemModal);